// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TrustRouteImport } from './routes/trust'
import { Route as SolutionsRouteImport } from './routes/solutions'
import { Route as PlatformRouteImport } from './routes/platform'
import { Route as LoginRouteImport } from './routes/login'
import { Route as KornerAskRouteImport } from './routes/korner-ask'
import { Route as IntelligenceRouteImport } from './routes/intelligence'
import { Route as FontTestRouteImport } from './routes/font-test'
import { Route as ExperienceRouteImport } from './routes/experience'
import { Route as ExecutiveRouteImport } from './routes/executive'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as ChefBuddyRouteImport } from './routes/chef-buddy'
import { Route as ChefBrainRouteImport } from './routes/chef-brain'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AffiliatesRouteImport } from './routes/affiliates'
import { Route as AffiliateRouteImport } from './routes/affiliate'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAdminPostsNewRouteImport } from './routes/_authenticated/admin.posts.new'
import { Route as AuthenticatedAdminPostsIdRouteImport } from './routes/_authenticated/admin.posts.$id'

const TrustRoute = TrustRouteImport.update({
            id: '/trust',path: '/trust',getParentRoute: () => rootRouteImport
          })
const SolutionsRoute = SolutionsRouteImport.update({
            id: '/solutions',path: '/solutions',getParentRoute: () => rootRouteImport
          })
const PlatformRoute = PlatformRouteImport.update({
            id: '/platform',path: '/platform',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const KornerAskRoute = KornerAskRouteImport.update({
            id: '/korner-ask',path: '/korner-ask',getParentRoute: () => rootRouteImport
          })
const IntelligenceRoute = IntelligenceRouteImport.update({
            id: '/intelligence',path: '/intelligence',getParentRoute: () => rootRouteImport
          })
const FontTestRoute = FontTestRouteImport.update({
            id: '/font-test',path: '/font-test',getParentRoute: () => rootRouteImport
          })
const ExperienceRoute = ExperienceRouteImport.update({
            id: '/experience',path: '/experience',getParentRoute: () => rootRouteImport
          })
const ExecutiveRoute = ExecutiveRouteImport.update({
            id: '/executive',path: '/executive',getParentRoute: () => rootRouteImport
          })
const DemoRoute = DemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => rootRouteImport
          })
const ChefBuddyRoute = ChefBuddyRouteImport.update({
            id: '/chef-buddy',path: '/chef-buddy',getParentRoute: () => rootRouteImport
          })
const ChefBrainRoute = ChefBrainRouteImport.update({
            id: '/chef-brain',path: '/chef-brain',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AffiliatesRoute = AffiliatesRouteImport.update({
            id: '/affiliates',path: '/affiliates',getParentRoute: () => rootRouteImport
          })
const AffiliateRoute = AffiliateRouteImport.update({
            id: '/affiliate',path: '/affiliate',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminPostsNewRoute = AuthenticatedAdminPostsNewRouteImport.update({
            id: '/posts/new',path: '/posts/new',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPostsIdRoute = AuthenticatedAdminPostsIdRouteImport.update({
            id: '/posts/$id',path: '/posts/$id',getParentRoute: () => AuthenticatedAdminRoute
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminPostsIdRoute: AuthenticatedAdminPostsIdRoute,AuthenticatedAdminPostsNewRoute: AuthenticatedAdminPostsNewRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AffiliateRoute: AffiliateRoute,AffiliatesRoute: AffiliatesRoute,AuthRoute: AuthRoute,BlogRoute: BlogRouteWithChildren,ChefBrainRoute: ChefBrainRoute,ChefBuddyRoute: ChefBuddyRoute,DemoRoute: DemoRoute,ExecutiveRoute: ExecutiveRoute,ExperienceRoute: ExperienceRoute,FontTestRoute: FontTestRoute,IntelligenceRoute: IntelligenceRoute,KornerAskRoute: KornerAskRoute,LoginRoute: LoginRoute,PlatformRoute: PlatformRoute,SolutionsRoute: SolutionsRoute,TrustRoute: TrustRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)